<template>
  <b-tag :type="type" size="is-small">
    <slot name="actions" :code="code"></slot>
  </b-tag>
</template>

<script>
export default {
  props: {
    code: {
      type: Object,
      default: () => []
    }
  },
  computed: {
    type() {
      if (this.isContainsError) {
        return 'is-danger';
      } else if (this.code.type.declarationType === 'unsetted') {
        return 'is-primary';
      } else if (this.code.type.declarationType === 'inherited') {
        return 'is-success';
      } else if (this.code.type.declarationType === 'setted') {
        return 'is-info';
      } else {
        return 'is-warning';
      }
    },

    isContainsError() {
      return (
        this.code.type.typeName === 'variable' &&
        (this.code.type.declarationType === '' ||
          this.code.type.declarationType == null ||
          this.code.selectedId == null)
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>
